import React, { FC, useContext, useState } from 'react';
import { Menu, Container, Image, Icon, Modal } from 'semantic-ui-react';
import { AppContext, AppContextType } from '../../App';
import { Link, useHistory, useLocation } from 'react-router-dom';
import logoImage from '../../Assets/Images/DDS_Logo.jpg';
import Swal from 'sweetalert2';
import { utils } from '../../helpers/utils';
import { reduce } from 'lodash';
import ChangePasswordForm from '../Pages/Users/ChangePasswordForm';


type LayoutProps = {
    publicSiteURLList: string[];
} & AppContextType;

const Layout: FC<LayoutProps> = ({ publicSiteURLList, children }) => {
    const { isLoggedIn, currentUser }: AppContextType = useContext(AppContext);
    const handleLogin = () => {
        console.log('click');
    }
    const currLocation = useLocation();
    const isPublic: boolean = getIsPublic(publicSiteURLList, currLocation.pathname);
    const rootElement = document.documentElement;
    if (isPublic) {
        rootElement.style.fontSize = '9px';
    } else {
        rootElement.style.fontSize = '14px';
    }

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    function getIsPublic(URLList: string[], currPathName: string) {
        let result: boolean = false;
        URLList.forEach((item) => {
            if (currPathName.toLowerCase().includes(item.toLocaleLowerCase())) {
                result = true;
            }
        });
        if (currPathName === '/') {
            result = true;
        }
        return result;
    }


    const handleLogout = () => {
        Swal.fire(
            {
                icon: 'warning',
                title: 'Confirm Logout',
                text: "Would you like to log out?",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "OK",
                cancelButtonText: "Cancel",
                confirmButtonColor: '#1678c2'
            }
        ).then((result) => {
            if (result.value) {
                utils.clearLocalToken();
                setTimeout(() => {
                    window.location.href = `${process.env.REACT_APP_VIRTUAL_DIRECTORY}`
                }, 500);
            }

        });

    }



    if (isPublic) {
        return (<>{children}</>);
    }

    return (
        <>
            <div>
                <Menu fixed='top' stackable color={'red'} inverted>
                    <Menu.Item className='logo-img-container'>
                        <Image className='logo-img' src={logoImage} />
                    </Menu.Item>
                    <Menu.Item>
                        Virtual Resource Room Website Administration
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item >
                            <span><Icon name='home' /><Link to='/' style={{ color: 'white' }}>Public Home Page</Link></span>
                        </Menu.Item>
                        {
                            isLoggedIn && currentUser &&
                            <Menu.Item>
                                <span><Icon name='user' />{currentUser.FullName}</span>
                            </Menu.Item>
                        }
                        {
                            isLoggedIn && currentUser &&
                            <Menu.Item onClick={()=>{setIsModalOpen(true)}}>
                                <span><Icon name='edit' />Change password</span>
                            </Menu.Item>
                        }
                        {
                            isLoggedIn &&
                            <Menu.Item onClick={handleLogout}>
                                <span><Icon name='sign out' />Sign out</span>
                            </Menu.Item>
                        }
                        {
                            !isLoggedIn && window.location.pathname !== '/login' &&
                            <Menu.Item onClick={handleLogin}>
                                <span><Icon name='sign in' /><Link to='/login' style={{ color: 'white' }}>Sign in</Link></span>
                            </Menu.Item>
                        }

                    </Menu.Menu>
                </Menu>
                <Container className='main-content'>
                    {children}
                </Container>
            </div>
            <Modal
                dimmer={'blurring'}
                open={isModalOpen}
                onClose={() => { setIsModalOpen(false) }}
            >
                <Modal.Header>Change Password</Modal.Header>
                <Modal.Content>
                    <ChangePasswordForm
                        closePopup={()=>{setIsModalOpen(false);}}
                    />
                </Modal.Content>
            </Modal>
        </>
    );
}

export default Layout;